<svg stroke="var(--icon-color)" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 3L8 12M12 8L8 12L4 8" stroke-width="1.5" />
</svg>

